import i18nHelper from '../dow-platform/components/commerce/myAccount/helper/i18n-helper'
import store from '@/store'
import LanguageHelper from './language-helper'

export default class ContractDetailsDataHelper {
    static store = store

    static getStatusToolTip() {
        return (
            i18nHelper.getI18nMessage('contract.need.approval') +
            '\n' +
            i18nHelper.getI18nMessage('contract.available.to.view') +
            '\n' +
            i18nHelper.getI18nMessage('contract.status.processing') +
            '\n' +
            i18nHelper.getI18nMessage('contract.status.pending') +
            '\n' +
            i18nHelper.getI18nMessage('contract.status.expired')
        )
    }

    static getContractStatus(contractDetails, contractItem) {
        if (contractItem.salesOrderNumbers) {
            return 'order.created'
        }
        if (contractItem.itemStatus) {
            return contractItem.itemStatus.toLowerCase().replace(/\s+/g, '.')
        }
        if (!contractItem.itemStatus && !contractItem.salesOrderNumbers) {
            if (ContractDetailsDataHelper.isContractExpired(contractDetails)) {
                return 'contract.expired'
            }
            return 'pending.approval'
        }
        return ''
    }

    static getContractActionText(contractDetails, contractItem) {
        if (contractDetails.combinedSalesOrderNumbers) {
            if(contractDetails.combinedSalesOrderNumbers.length > 1){
                return `${i18nHelper.getI18nMessage('view.orders.UPPER')}`
            }else{
                return `${i18nHelper.getI18nMessage(
                    'order.detail.rightRail.vieworder'
                )}: ${contractDetails.combinedSalesOrderNumbers[0].text}`
            }
        }
        if (contractItem.itemStatus) {
            return i18nHelper.getI18nMessage('contract.customer.service')
        }

        if (!contractItem.itemStatus && !contractDetails.combinedSalesOrderNumbers) {
            if (ContractDetailsDataHelper.isContractExpired(contractDetails)) {
                return i18nHelper.getI18nMessage('contract.customer.service')
            }
            return i18nHelper.getI18nMessage('approve.pending.order')
        }
        return ''
    }

    static showContractItemInDashboard(contractItem) {
        if (contractItem.itemStatus) {
            return true
        }
        if (!contractItem.itemStatus && !contractItem.salesOrderNumbers) {        
            return true           
        }
        return false
    }

    static getContractActionUrl(contractDetails, contractItem) {
        const languageCode = LanguageHelper.getLanguageCodeFromCookie()
        const supportUrl = `/${languageCode}/support.html`
        if (contractItem.salesOrderNumbers) {
            if(contractItem.salesOrderNumbers.length == 1){
                return ContractDetailsDataHelper.getOrderStatusUrl(contractItem)
            }
            return '#'
        }
        if (contractItem.itemStatus) {
            return supportUrl
        }
        if (!contractItem.itemStatus && !contractItem.salesOrderNumbers) {
            if (ContractDetailsDataHelper.isContractExpired(contractDetails)) {
                return supportUrl
            }
        }
        return '#'
    }

    static getOrderStatusUrl(contractItem) {
        const language = LanguageHelper.getLanguageFromLanguageCodeCookie()
        return `#/my-orders/order-details/${contractItem.salesOrderNumbers[0]}`
    }

    static isContractExpired(contractDetails) {
        const expiryDate = new Date(contractDetails.contractExpirationDate)
        const today = new Date()
        return expiryDate < today
    }

    static canApproveContract(contractDetails) {
        const contractItem = contractDetails.contractItems?.[0]
        // Convert expiryDate to a Date object
        const expiryDate = new Date(contractDetails.contractExpirationDate)
        const today = new Date()
        return (
            !contractItem.itemStatus &&
            !contractItem.salesOrderNumbers &&
            expiryDate > today
        )
    }
    static getAllOrderNumbers(contractDetails) {
        const orderNumbersGrouped = contractDetails.contractItems
        ? contractDetails.contractItems.reduce((acc, item) => item.salesOrderNumbers ? acc.concat(item.salesOrderNumbers) : acc, [])
        : [];
        const uniqueOrderNumbers = [...new Set(orderNumbersGrouped)];
        const orderNumbersArr = [];
        for (const [index, ordernumber] of uniqueOrderNumbers.entries()) {
            orderNumbersArr.push({
                text: ordernumber,
                value: index.toString()
            })        
        }
        const combinedSalesOrderList = orderNumbersArr.length > 0 ? orderNumbersArr : null;
        return combinedSalesOrderList
    }
}
